import { Box, IconButton, Text, TrashIcon } from '@razorpay/blade/components';
import { useState } from 'react';
import { StructureContribution } from '../types';
import { ComopnentWrapper } from './styles';

interface ContributionComponentProps {
  component: StructureContribution;
  onDelete: () => void;
}

export const ContributionComponentItem = ({
  component,
  onDelete,
}: ContributionComponentProps) => {
  const [isDeleting, setIsDeleting] = useState(false);
  return (
    <ComopnentWrapper isDeleting={isDeleting}>
      <Box
        paddingX="10px"
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        paddingY="spacing.3">
        <Box
          display="grid"
          gridTemplateColumns="1fr auto auto"
          alignItems="center"
          gap="spacing.3"
          width="100%">
          <Text size="medium">{component.name}</Text>

          <Box display="flex" flexDirection="column" placeSelf="flex-end" gap="spacing.1">
            <Text size="medium" weight="regular">
              {component.name}
            </Text>
            <Text variant="caption" size="small" weight="regular" color="surface.text.gray.muted">
              {component.description}
            </Text>
          </Box>

          <Box marginLeft="spacing.8">
            <IconButton
              isHighlighted
              icon={TrashIcon}
              onClick={onDelete}
              emphasis="intense"
              size="medium"
              onMouseMove={() => setIsDeleting(true)}
              onMouseLeave={() => setIsDeleting(false)}
              accessibilityLabel="Delete component"
            />
          </Box>
        </Box>
      </Box>
    </ComopnentWrapper>
  );
};
